export default __webpack_public_path__ + "static/media/dots.163f10b8.svg";